import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getReservationCreateShopSlice = createSlice({
    name: "getReservationCreateShop",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getReservationCreateShopSlice_actions = getReservationCreateShopSlice.actions;
export var fetchData = _getReservationCreateShopSlice_actions.fetchData, fetchDataSuccess = _getReservationCreateShopSlice_actions.fetchDataSuccess, fetchDataFailure = _getReservationCreateShopSlice_actions.fetchDataFailure, resetState = _getReservationCreateShopSlice_actions.resetState;
export default getReservationCreateShopSlice.reducer;
